import React, {Component} from 'react';
import Select from "../local_node_modules/react-select"

class AutoCompleteList extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.changeLabel = this.changeLabel.bind(this);
        this.createLabel = this.createLabel.bind(this);
        this.checkUpperCase = this.checkUpperCase.bind(this);
        this.generateOptions = this.generateOptions.bind(this);
    }

    changeLabel(value) {
        this.props.onChange(this.checkUpperCase(value));
    }

    createLabel(value) {
        if (this.props.allowNew) {
            let list = this.props.list;
            if (list.length === 0) {
                let newValue;
                if (!this.props.onlyLabel) {
                    newValue = {value: "0", label: this.checkUpperCase(value.label)};
                } else {
                    newValue = {value: this.checkUpperCase(value.label), label: this.checkUpperCase(value.label)};
                }
                list.push(newValue);
                this.props.updateList(list);
                this.changeLabel(newValue);
            } else {
                let i = list.length - 1;
                let valueCheck = list[i];
                if (!this.props.onlyLabel) {
                    if (valueCheck.value === "0") {
                        list[i].label = this.checkUpperCase(value.label);
                        this.props.updateList(list);
                        this.changeLabel(list[i]);
                    } else {
                        let newValue = {value: "0", label: this.checkUpperCase(value.label)};
                        list.push(newValue);
                        this.props.updateList(list);
                        this.changeLabel(newValue);
                    }
                } else {
                    if (valueCheck.value === this.checkUpperCase(value.label)) {
                        list[i].label = this.checkUpperCase(value.label);
                        this.props.updateList(list);
                        this.changeLabel(list[i]);
                    } else {
                        let newValue = {
                            value: this.checkUpperCase(value.label),
                            label: this.checkUpperCase(value.label)
                        };
                        list.push(newValue);
                        this.props.updateList(list);
                        this.changeLabel(newValue);
                    }
                }
            }
        }
    }

    checkUpperCase(text) {
        if (text && this.props.useUpperCase) {
            if (text.value && text.label) {
                text.label = text.label.toString().replace("i", "İ").toUpperCase();
            } else {
                text = text.toString().replace("i", "İ").toUpperCase();
            }
        }
        return text;
    }

    generateOptions() {
        let options = [];
        this.props.list &&
        this.props.list.length > 0 &&
        this.props.list.map(e => {
            options.push({value: e.value, label: this.checkUpperCase(e.label)})
        });
        return options;
    }

    formatCreateLabelCreator = (value) => {
        if (this.props.allowNew)
            return 'Ekle "' + value + '"';
        else
            return 'Lütfen, var olan bir ' + this.props.name + ' seçimi yapınız.'
    };

    render() {
        let options = this.generateOptions();
        return (
            <Select.Creatable
                clearable={false}
                multi={false}
                className="select-control"
                name="autoCompleteList"
                id="autoCompleteList"
                value={this.props.value}
                placeholder={this.props.placeholder}
                promptTextCreator={this.formatCreateLabelCreator}
                onChange={(e) => this.changeLabel(e)}
                onNewOptionClick={(e) => this.createLabel(e)}
                options={options}
            />
        );
    }
}

AutoCompleteList.defaultProps = {
  allowNew: true,
  useUpperCase: false,
  onlyLabel: false,
  updateList: (list) => {}
};
export default AutoCompleteList;
